import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'number-display',
  templateUrl: './number-display.component.html',
  styleUrls: ['./number-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class NumberDisplayComponent {
  @Input() public category: string;
  @Input() public number: number;
  @Input() public title: string;
  @Input() public isPrimary: boolean;
  @Input() public format: string;
}
